export default __webpack_public_path__ + "static/media/img-doc.54d6f23c.svg";